export default __webpack_public_path__ + "static/media/delete-small.7f2f61e3.svg";